// extracted by mini-css-extract-plugin
export default {"card":"PortfolioCard_card__cqyVf","image":"PortfolioCard_image__7YVRw","details":"PortfolioCard_details__rQzd9","features":"PortfolioCard_features__IOwYf"};